import Text from 'components/base/Text';
import { Padding } from 'components/base/layout-components';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import _ from 'lodash';
import HideShowCopyTextField from 'components/HideShowCopyTextField/HideShowCopyTextField';
import ConfirmationDialog from 'dialogs/ConfirmationDialog';

const BodyWrapper = styled(Padding)`
border-bottom: solid 1px ${getColor('botticelli')}
margin-bottom: 1rem;
`;

const DialogBody = ({ apiToken }) => {
  return (
    <div>
      <BodyWrapper b='small'>
        <Text size='medium'>
          Are you sure you would like to revoke the following token:
        </Text>
      </BodyWrapper>
      <Text size='medium'>{_.get(apiToken, 'label', '')}:</Text>
      <HideShowCopyTextField
        paddingLeftEnabled={false}
        initiallyVisible={false}
        showVisibilityToggle={false}
        showCopy={false}
        stringLength={32}
        hiddenCharacter={'&middot;'}
        hiddenPrefix={_.get(apiToken, 'prefix', '')}
      />
    </div>
  );
};

const RevokeTokenConfirmationDialog = ({
  revokingToken,
  onConfirm,
  onCancel
}) => {
  return (
    <ConfirmationDialog
      data-testid='revoke-token-confirmation-dialog'
      title={`Revoke ${_.get(revokingToken, 'label', '')} token?`}
      content={<DialogBody apiToken={revokingToken} />}
      confirmText='Yes, revoke token'
      cancelText='No, keep token'
      isOpen={Boolean(revokingToken)}
      onCancel={onCancel}
      onConfirm={onConfirm}
      justifyButtons='flex-end'
      cancelButtonType='outlined'
      okButtonType='contained'
    />
  );
};

export default RevokeTokenConfirmationDialog;
